import React from 'react';
import {TrackedComponent} from 'react-appinsights'
import flow from 'lodash/flow'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'

import withStyles from 'material-ui/styles/withStyles'
import {NProgress} from 'redux-nprogress';

import global from '../style/global'

import SiteFrame from './SiteFrame'
import Routes from './Routes'

class App extends TrackedComponent {
    render() {
        return (<SiteFrame>
                <NProgress />
                <Routes />
            </SiteFrame>
        );
    }
}

const mapStateToProps = () => ({});

const styles = theme => ({
    ...global(theme)
});

export default flow([
    connect(mapStateToProps),
    withStyles(styles),
    withRouter
])(App);



// WEBPACK FOOTER //
// ./src/components/App.js